var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('table-component',{attrs:{"items":_vm.items,"busy":_vm.busy,"fields":_vm.fields}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }